import { getLegacyBindingContext } from "@visactor/vrender-core/legacy/bootstrap";

import { registerPathGraphic } from "@visactor/vrender-core/register/graphic";

import { pathModule } from "@visactor/vrender-core/graphic/modules";

import { browser } from "./env";

import { bindPathCanvasPickerContribution } from "../picker/contributions/canvas-picker/path-module";

import { bindPathMathPickerContribution } from "../picker/contributions/math-picker/path-module";

function _registerPath() {
    if (_registerPath.__loaded) return;
    _registerPath.__loaded = !0;
    const legacyContext = getLegacyBindingContext();
    registerPathGraphic(), pathModule({
        bind: legacyContext.bind
    }), browser ? bindPathCanvasPickerContribution(legacyContext) : bindPathMathPickerContribution(legacyContext);
}

_registerPath.__loaded = !1;

export const registerPath = _registerPath;
//# sourceMappingURL=register-path.js.map